import type { CaptureResult } from 'posthog-js';
import { PHI_FIELDS, PHI_ROUTES } from './constants';

const DYNAMIC_ID_ROUTE_PATTERNS: Array<{ pattern: RegExp; replacement: string }> = [
  { pattern: /^\/result\/[^/?#]+/, replacement: '/result/:id' },
  { pattern: /^\/recording\/[^/?#]+/, replacement: '/recording/:id' },
];

const URL_PROPERTY_KEYS = ['$current_url', '$pathname', '$referrer', 'pathname'];

export function sanitizePathname(pathname: string): string {
  for (const { pattern, replacement } of DYNAMIC_ID_ROUTE_PATTERNS) {
    if (pattern.test(pathname)) {
      return pathname.replace(pattern, replacement);
    }
  }
  return pathname;
}

export function sanitizeUrl(value: string): string {
  try {
    const url = new URL(value);
    url.pathname = sanitizePathname(url.pathname);
    return url.toString();
  } catch {
    return sanitizePathname(value);
  }
}

export function sanitizeUrlProperties(
  properties: Record<string, unknown>
): Record<string, unknown> {
  const sanitized = { ...properties };

  URL_PROPERTY_KEYS.forEach((key) => {
    const value = sanitized[key];
    if (typeof value === 'string') {
      sanitized[key] = sanitizeUrl(value);
    }
  });

  return sanitized;
}

export function getPathNameFromEvent(event: CaptureResult): string {
  return event.properties?.$current_url
    ? new URL(event.properties.$current_url as string).pathname
    : window.location.pathname;
}

export function isPHIRoute(pathname: string): boolean {
  return PHI_ROUTES.some((route) => pathname.startsWith(route));
}

export function sanitizeProperties(properties: Record<string, unknown>): Record<string, unknown> {
  const sanitized = sanitizeUrlProperties(properties);

  PHI_FIELDS.forEach((field) => {
    if (sanitized[field] !== undefined) {
      sanitized[field] = '[REDACTED]';
    }
  });

  return sanitized;
}
